export const iconFontAwesomeBuildingsLandmarkFlag = (
	<i className="fa-solid fa-landmark-flag"></i>
);
